<template>
    <div>
        <vx-card title="Benefits" subtitle="Lists of Employee Benefits"  class="no-scroll-content" >


        <!-- <p>You can have a sebra effect by adding the property <code>stripe</code></p><br> -->
        <vs-button type="gradient" color="primary" @click="promptAddNewBenefits()"  icon-pack="feather" icon="icon-plus">Add</vs-button>

        <div class="vx-col w-full mb-base">
            <template>
                <vs-table stripe v-model="selected"  search  :data="employeeBenefits">
                    <template slot="thead">
                        <vs-th>Benefit Type</vs-th>
                        <vs-th>Policy No</vs-th>
                        <vs-th>Date Issued</vs-th>
                        <vs-th>Cost</vs-th>
                        <vs-th>Coverage Amounts</vs-th>
                        <vs-th>Start Date</vs-th>
                        <vs-th>End Date</vs-th>
                        <vs-th>No EndDate</vs-th>
                        <vs-th>Remarks</vs-th>
                        <vs-th>Action</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].benefitTypeId">
                                {{ benefitTypeName(data[indextr].benefitTypeId).benefitTypeName }}
                            </vs-td>
                            <vs-td :data="data[indextr].policyNo">
                                {{data[indextr].policyNo}}
                            </vs-td>
                            <vs-td :data="data[indextr].dateIssued">
                                {{data[indextr].dateIssued | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].cost">
                                {{data[indextr].cost}}
                            </vs-td>
                            <vs-td :data="data[indextr].coverageAmount">
                                {{data[indextr].coverageAmount}}
                            </vs-td>
                            <vs-td :data="data[indextr].startDate">
                                {{data[indextr].startDate | fulldate}}
                            </vs-td>
                            <vs-td :data="data[indextr].endDate">
                                {{data[indextr].endDate | fulldate }}
                            </vs-td>
                            <vs-td :data="data[indextr].isNoEndDate" >
                                <vs-checkbox v-model="data[indextr].isNoEndDate" disabled="true"/>
                            </vs-td>
                            <vs-td :data="data[indextr].remarks">
                                {{data[indextr].remarks}}
                            </vs-td>
                            <vs-td>
                                <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
                                    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord(data[indextr].id)" />
                                    <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr].id)" />
                                </div>
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </template>
             
        </div>

            <!-- ADD ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Benefits"
                accept-text= "Submit"
                @accept="onAddBenefits"
                :is-valid="validForm"
                :active.sync="activePromptNewBenefits">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Benefits Type</span><span style="color:red">*</span>
                        <v-select name="benefits-name" v-model="benefitType" label="benefitTypeName" :options="getAllBenefitTypeLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Cost</span><span style="color:red">*</span>
                        <vs-input v-validate="'numeric|max_value:200000'" name="cost" class="w-full" v-model="cost" placeholder="0.00"/>
                        <span class="text-danger text-sm" v-show="errors.has('cost')">{{ errors.first('cost') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Coverage Amount</span><span style="color:red">*</span>
                        <vs-input v-validate="'numeric|max_value:1000000'" name="coverage amount" class="w-full" v-model="coverageAmount" placeholder="0.00"/>
                        <span class="text-danger text-sm" v-show="errors.has('coverage amount')">{{ errors.first('coverage amount') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Policy No</span>
                        <vs-input name="policyNo-name" class="w-full" v-model="policyNo" placeholder="Policy No"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Issued</span><span style="color:red">*</span>
                         <datepicker :format="format" v-model="dateIssued" placeholder="Select Date"/>
                     </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                        <datepicker :format="format" v-model="startDate" placeholder="Select Date"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">End Date</span>
                        <datepicker :format="format" v-model="endDate" placeholder="Select Date" v-bind:disabled="isNoEndDate === true ? true : false"/>

                    </div>
                </div>
               <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <vs-checkbox  v-model="isNoEndDate">No EndDate?</vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>

            
                </vx-card>
            </vs-prompt>




                 <!-- EDIT ACCREDITATION -->
            <vs-prompt
                class="email-compose"
                title="Benefits"
                accept-text= "Submit"
                @accept="onEditBenefits"
                :is-valid="validForm"
                :active.sync="activePromptEditBenefits">
                <vx-card title="Fill-out the following information">


                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-2/2 md:w-2/2 lg:w-2/2 xl:w-2/2 w-full mb-2">
                        <span  class="text-sm">Benefits Type</span><span style="color:red">*</span>
                        <v-select name="benefits-name" v-model="benefitType" label="benefitTypeName" :options="getAllBenefitTypeLookup" placeholder="Please Select" />

                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Cost</span><span style="color:red">*</span>
                        <vs-input v-validate="'numeric|max_value:200000'" name="cost" class="w-full" v-model="cost" placeholder="0.00"/>
                        <span class="text-danger text-sm" v-show="errors.has('cost')">{{ errors.first('cost') }}</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Coverage Amount</span><span style="color:red">*</span>
                        <vs-input v-validate="'numeric|max_value:1000000'" name="coverage amount" class="w-full" v-model="coverageAmount" placeholder="0.00"/>
                        <span class="text-danger text-sm" v-show="errors.has('coverage amount')">{{ errors.first('coverage amount') }}</span>
                    </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Policy No</span>
                        <vs-input name="policyNo-name" class="w-full" v-model="policyNo" placeholder="Policy No"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Date Issued</span><span style="color:red">*</span>
                         <datepicker :format="format" v-model="dateIssued" placeholder="Select Date"/>
                     </div>
                </div>
                <div class="vx-row mb-3">
                    <div class="vx-col sm:w-1/2 w-full mb-4">
                        <span  class="text-sm">Start Date</span><span style="color:red">*</span>
                        <datepicker :format="format" v-model="startDate" placeholder="Select Date"/>

                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-4" >
                        <span  class="text-sm">End Date</span>
                        <datepicker :format="format" v-model="endDate" placeholder="Select Date" v-bind:disabled="isNoEndDate === true ? true : false"/>

                    </div>
                </div>
               <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <vs-checkbox  v-model="isNoEndDate">No EndDate?</vs-checkbox>
                    </div>
                </div>
                <div class="vx-row mb-2">
                    <div class="vx-col w-full mb-2">
                        <span class="text-sm">Remarks</span>
                        <vs-input name="remarks-name" class="w-full" v-model="remarks" placeholder="Remarks" />
                    </div>
                </div>


            
                </vx-card>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker'
import { en, he } from 'vuejs-datepicker/src/locale'

import moment from 'moment'
import vSelect from 'vue-select'

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    data() {
        return {
            selected            : [],
            id                  : 0,
            benefitType         : [],
            policyNo            : '',
            cost                : '',
            coverageAmount      : '',
            dateIssued          : null,
            startDate           : null,
            endDate             : null,
            isNoEndDate         : true,
            remarks             : '',
            userId              : null,

            uid                 : null,
            activePromptNewBenefits    : false,
            activePromptEditBenefits    : false,

            format: "d MMMM yyyy",
        }
    },
    created() {
            this.$vs.loading()
            // this.$store.dispatch('hrms/getAllBenefits', { userId : null})
            this.$store.dispatch('lookup/getAllBenefitTypeLookup')
            .then(res => { this.$vs.loading.close() })
                .catch(error => { 
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                        })
                })
            this.uid = this.$route.params.id
            this.employeeBenefits = this.uid
            //  this.$store.dispatch('hrms/getAllBenefits',  this.uid )
            
    },
    computed: {
        employeeBenefits: {
           
           get() { return this.$store.state.hrms.employeeBenefits },
           set(value) { this.$store.dispatch('hrms/getAllBenefits',  value )}
            
        },
        validForm(){
            return this.benefitType != null &&
            this.dateIssued != '' && this.startDate !=null && this.coverageAmount != null && this.cost
            
        },
        getAllBenefitTypeLookup() {
            return this.$store.state.lookup.getAllBenefitTypeLookup
        },
        getRank() {
             return this.$store.state.lookup.getAllRankLookup
        },
        benefitTypeName() {
            return (id) => this.$store.getters['lookup/benefitTypeLookup'](id)
        },
    },
    methods: {
        promptAddNewBenefits() {
            this.activePromptNewBenefits = true
        },
        onAddBenefits() {
            this.$validator.validateAll().then(result => {
            if (result) {
                this.$vs.loading()

                const data = {
                    benefitTypeId: this.benefitType.benefitTypeId,
                    policyNo : this.policyNo,
                    dateIssued: this.dateIssued,
                    cost: this.cost,
                    coverageAmount: this.coverageAmount,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    isNoEndDate: this.isNoEndDate,
                    remarks: this.remarks,
                    userId: this.uid,
                    currentUserId: this.$store.state.AppActiveUser.uid
                }

                this.$store.dispatch('hrms/AddBenefits', data)
                .then((response) =>{
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Accredition Saved',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
            } else {
            // form have errors
              this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
            }
            })
        },
        onEditBenefits() {
            this.$validator.validateAll().then(result => {
            if (result) {
                const data = {
                    id                  : this.id,
                    benefitTypeId       : this.benefitType.benefitTypeId,
                    policyNo            : this.policyNo,
                    dateIssued          : this.dateIssued,
                    cost                : this.cost,
                    coverageAmount      : this.coverageAmount,
                    startDate           : this.startDate,
                    endDate             : this.endDate,
                    isNoEndDate         : this.isNoEndDate,
                    remarks             : this.remarks,
                    userId              : this.uid,
                    currentUserId           : this.$store.state.AppActiveUser.uid
                }
                this.$store.dispatch('hrms/UpdateBenefits', data)
                    .then(response => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Success',
                            text: 'Benefits Updated',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle',
                            color: 'success'                  
                            })
                    })
                    .catch(error => {
                            this.$vs.loading.close()
                            this.$vs.notify({
                            title: 'Error',
                            text: error.message,
                            iconPack: 'feather',
                            icon: 'icon-x-octagon',
                            color: 'danger'
                        })
                    })
                } else {
            // form have errors
              this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
            }
            })
        },
        editRecord(Id) {

            const e = this.$store.getters['hrms/employeeBenefits'](Id)
            this.id                  = e.id,
            this.benefitType            = this.benefitTypeName(e.benefitTypeId),
            this.policyNo            = e.policyNo,
            this.dateIssued          = e.dateIssued,
            this.cost                = e.cost,
            this.coverageAmount      = e.coverageAmount,
            this.startDate           = e.startDate,
            this.endDate             = e.endDate,
            this.isNoEndDate         = e.isNoEndDate,
            this.remarks             = e.remarks
            this.userId              = e.userId

            this.activePromptEditBenefits = true
        },
        confirmDeleteRecord(id) {
            this.$store.dispatch('hrms/DeleteBenefits', id)
            .then(res => {
                this.$vs.loading.close()
                        this.employeeBenefits = this.uid
                        this.$vs.notify({
                        title: 'Success',
                        text: 'Benefits Deleted',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success'                  
                        })
                   })
                .catch(error => {
                        this.$vs.loading.close()
                        this.$vs.notify({
                        title: 'Error',
                        text: error.message,
                        iconPack: 'feather',
                        icon: 'icon-x-octagon',
                        color: 'danger'
                    })
                })
        }
    },
    components: {
        'v-select': vSelect,
        Datepicker,
        flatPickr,
        // VuePerfectScrollbar,
    },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>